export const GET_LIST_NASABAH_BRI = 'GetListNasabahBRI/Success';
export const LOADING_GET_LIST_NASABAH_BRI = 'GetListNasabahBRI/Loading';

export const GET_LIST_NASABAH_NON_BRI = 'GetListNasabahNonBRI/Success';
export const LOADING_GET_LIST_NASABAH_NON_BRI = 'GetListNasabahNonBRI/Loading';

export const GET_LIST_NASABAH_DITINDAKLANJUTI = 'GetListNasabahDitindaklanjuti/Success';
export const LOADING_GET_LIST_NASABAH_DITINDAKLANJUTI= 'GetListNasabahDitindaklanjuti/Loading';

export const GET_ONBOARDING = 'GetOnboarding/Success';
export const LOADING_GET_ONBOARDING= 'GetOnboarding/Loading';

export const GET_DETAIL_NASABAH_BRI = 'GetDetailNasabahBRI/Success';
export const LOADING_GET_DETAIL_NASABAH_BRI= 'GetDetailNasabahBRI/Loading';

export const GET_DETAIL_NASABAH_DITINDAKLANJUTI = 'GetDetailNasabahDitindaklanjuti/Success';
export const LOADING_GET_DETAIL_NASABAH_DITINDAKLANJUTI= 'GetDetailNasabahDitindaklanjuti/Loading';

export const GET_LIST_ALASAN_TIDAK_DAPAT_DIHUBUNGI = 'GetListAlasanTidakDapatDihubungi/Success';
export const LOADING_GET_LIST_ALASAN_TIDAK_DAPAT_DIHUBUNGI = 'GetListAlasanTidakDapatDihubungi/Loading';

export const GET_LIST_ALASAN_TIDAK_COCOK = 'GetListAlasanTidakCocok/Success';
export const LOADING_GET_LIST_ALASAN_TIDAK_COCOK = 'GetListAlasanTidakCocok/Loading';

export const GET_INFORMASI_TIER_NASABAH = 'GetInformasiTierNasabah/Success';
export const LOADING_GET_INFORMASI_TIER_NASABAH = 'GetInformasiTierNasabah/Loading';

export const SUBMIT_TINDAKLANJUT_POSITIF_CASE_1 = 'SubmitTindakLanjutPositifCase1/Success'
export const SUBMIT_TINDAKLANJUT_POSITIF_CASE_2 = 'SubmitTindakLanjutPositifCase2/Success'
export const SUBMIT_TINDAKLANJUT_NEGATIF_CASE_1 = 'SubmitTindakLanjutNegatifCase1/Success'
export const SUBMIT_TINDAKLANJUT_NEGATIF_CASE_2 = 'SubmitTindakLanjutNegatifCase2/Success'
export const SUBMIT_TINDAKLANJUT_NEGATIF_CASE_3 = 'SubmitTindakLanjutNegatifCase3/Success'
export const SUBMIT_TINDAKLANJUT_OTHER_CASE = 'SubmitTindakLanjutOtherCase/Success'
export const LOADING_SUBMIT_TINDAKLANJUT = 'SubmitTindakLanjut/Loading'

export const INFINITE_SCROLL_NASABAH_BRI = 'InfiniteScrollNasabahBRI/Success'
export const INFINITE_SCROLL_NASABAH_NON_BRI = 'InfiniteScrollNasabahNonBRI/Success'
export const INFINITE_SCROLL_NASABAH_DITINDAKLANJUTI = 'InfiniteScrollNasabahDItindaklanjuti/Success'
export const LOADING_INFINITE_SCROLL = 'InfiniteScroll/Loading'

